<script>
    import Saos from "saos";
    import { _ } from "svelte-i18n";
</script>

<div class="demo">
  <Saos animation={"scale-in-hor-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both"}>
    <img width="600" src="img/Construction tape.svg" alt="Construction tape"/>
  </Saos>
  <p>
    {$_("demo_page.p-0")}
  </p>
  <Saos animation={"scale-in-hor-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both"}>
    <img width="600" src="img/Construction tape.svg" alt="Construction tape"/>
  </Saos>
</div>

<style>
  @keyframes -global-scale-in-hor-left {
    0% {
      transform: scaleX(0);
      transform-origin: 0% 0%;
      opacity: 1;
    }
    100% {
      transform: scaleX(1);
      transform-origin: 0% 0%;
      opacity: 1;
    }
  }
  @keyframes -global-scale-in-hor-right {
    0% {
      transform: scaleX(0);
      transform-origin: 100% 100%;
      opacity: 1;
    }
    100% {
      transform: scaleX(1);
      transform-origin: 100% 100%;
      opacity: 1;
    }
  }

  .demo {
    text-align: center;
  }
  p {
    color: #fa053c;
    font-weight: bold;
  }
</style>